// Images
import Lang from "../../images/Language Translate2.0.png";
import Favicon from "../../images/Favicon.svg";
// React
import { useState, useEffect, useContext } from "react";
import { Disclosure, Menu } from "@headlessui/react";
import { useLocation, NavLink } from "react-router-dom";
//Services
import { GET, LOGOUT } from "../../service/CRUDService";
// Constants
import EntityConstants from "../../configs/EntityConstants";
// Store
import AuthContext from "../../store/auth-context";
// React Icons
import { BiLogOutCircle } from "react-icons/bi";
import toast from "react-hot-toast";
import { useTranslation } from "react-i18next";
import AppConstants from "../../configs/AppConstants";
import { googleLogout } from "@react-oauth/google";
import { useGoogleOneTapLogin } from "@react-oauth/google";
import { GLogin } from "../../service/OAuthLogin";
import ProfileIcon from "../../resources/icons/profile-circle.svg";
import NotificationIcon from "../../resources/icons/notification.svg";
import HelpIcon from "../../resources/icons/message-question.svg";
import { BaseLayoutContext } from "../../store/BaseLayoutContext";
import { MLogin } from "../../service/OAuthLogin";
import useInterceptedNavigate from "../../hooks/useInterceptedNavigate";
import { LanguagesIcon } from "lucide-react";
import { useTheme } from "../../store/ThemeContext";
import { getMicrosoftOAuthRedirectUri } from "../../utils/microsoftOAuthRedirectUri";
import LanguageSwitch from "../LanguageSwitch/LanguageSwitch";
import { isLanguageSwitchEnabled } from "../../configs/featureFlags";

//main NavBar component
export default function Navbar() {
  const { TriggerLoginModuleBtn, chooseSignUp_SignIn } =
    useContext(BaseLayoutContext);
  const { t, i18n } = useTranslation();
  const location = useLocation();
  const navigate = useInterceptedNavigate();
  const authContext = useContext(AuthContext);
  const home = "/";
  const [code, setCode] = useState("");
  const [navbarBgColor, setNavbarBgColor] = useState("");
  const [navbarLogo, setNavbarLogo] = useState("");
  const [authProviders, setAuthProviders] = useState([]);
  const { availableLanguages } = useTheme();

  // Google One Tap login disabled
  // useGoogleOneTapLogin({
  //   disabled: authContext.isLoggedIn || authProviders.signin === "google",
  //   onSuccess: async (credentialResponse) => {
  //     const login = await GLogin(credentialResponse, "success");
  //     if (login === true) {
  //       authContext.login() && authContext.googlelogin();
  //     }
  //   },
  //   onError: (error) => GLogin(error, "failed"),
  //   googleAccountConfigs: {
  //     client_id: AppConstants.CLIENT_ID,
  //   },
  // });

  const [language, setLanguage] = useState(() => {
    const savedLang =
      authContext.selectedLanguage ||
      localStorage.getItem("selectedLanguage") ||
      (availableLanguages.length > 0 ? availableLanguages[0].value : "en");
    return (
      availableLanguages.find((l) => l.value === savedLang) ||
      availableLanguages[0]
    );
  });

  useEffect(() => {
    if (availableLanguages.length > 0) {
      const savedLang =
        authContext.selectedLanguage ||
        localStorage.getItem("selectedLanguage");
      const matched = availableLanguages.find((l) => l.value === savedLang);
      setLanguage(matched || availableLanguages[0]);
    }
  }, [availableLanguages]);

  const logout = async () => {
    try {
      authContext.isGoogleLogin && googleLogout(); // ONLY DO IT IF GOOGLE LOGIN IS USED //! NOW DOING IT ALL TYPES OF LOGIN
      const response = await LOGOUT(EntityConstants.LOGOUT);

      if (response.ok) {
        authContext.createUserProfileDetails({});
        localStorage.clear();
        authContext.logout();
        authContext.createUserProfile(null);
        authContext.createTenantName(null);
        authContext.createTenantId(null);
        location.pathname.startsWith("/verifier") && navigate("/");
      }
    } catch (error) {
      // Handle errors here, you can use console.error or any logging mechanism
      toast.error("Logout failed:", error);
    }
  };

  const handleCurrentUser = async (loginType = null) => {
    try {
      const [userResult, permsResult] = await Promise.allSettled([
        GET(EntityConstants.CURRENT_USER),
        GET(EntityConstants.VERIFIER_PERMISSIONS),
      ]);

      if (userResult.status !== "fulfilled") {
        throw userResult.reason || new Error("Failed to fetch current user");
      }

      const data = await userResult.value.json();

      let sidebar_components = [];
      if (permsResult.status === "fulfilled") {
        try {
          const permsData = await permsResult.value.json();
          sidebar_components = Array.isArray(permsData.sidebar_components)
            ? permsData.sidebar_components
            : [];
        } catch (permissionsError) {
          console.error(
            "Failed to parse sidebar permissions:",
            permissionsError,
          );
        }
      } else {
        console.error(
          "Failed to fetch sidebar permissions:",
          permsResult.reason,
        );
      }

      const mergedUserData = {
        ...data,
        sidebar_components,
      };

      if (
        mergedUserData?.type &&
        ["admin", "admin_verifier", "admin_requester", "verifier"].includes(
          mergedUserData.type.toLowerCase(),
        )
      ) {
        authContext.login(mergedUserData);
        if (loginType === "password") {
          authContext.createUserProfileDetails(mergedUserData);
        } else if (loginType === "google") {
          authContext.createUserProfileDetails({
            first_name: mergedUserData.given_name,
            last_name: mergedUserData.family_name,
            email: mergedUserData.email,
            profile_photo: mergedUserData.image_url,
            type: mergedUserData.type,
            sidebar_components: mergedUserData.sidebar_components,
          });
        }

        authContext.createUserProfile(mergedUserData.user_profile_id);
        authContext.createTenantName(mergedUserData.tenant_name);
        authContext.createTenantId(mergedUserData.tenant_id);
      } else {
        toast.error("Please login with a valid account.");
        logout();
        return;
      }
    } catch (error) {
      console.error("Failed to fetch current user:", error);
      toast.error("An unexpected error occurred. Please try again.");
    }
  };

  const GET_PRODUCT_DETAILS = async () => {
    try {
      const response = await GET(EntityConstants.GET_ORGANISATION_DETAILS);
      const data = await response.json();

      if (response.ok) {
        setNavbarLogo(data.navbar_logo);
        setNavbarBgColor(data.navbar_background_color);
      } else {
        console.log("Error:", data);
      }
    } catch (error) {
      console.error("Assets fetch failed:", error);
    }
  };

  useEffect(() => {
    GET_PRODUCT_DETAILS();
  }, []);

  const handleMicrosoftRedirect = async () => {
    try {
      const codeVerifier = sessionStorage.getItem("pkce_code_verifier");
      if (!codeVerifier) {
        toast.error(t("navbar:microsoft_pkce_missing"));
        window.history.replaceState(
          {},
          document.title,
          window.location.pathname + window.location.hash,
        );
        setCode("");
        return;
      }

      const redirectUri = getMicrosoftOAuthRedirectUri();

      const response = await fetch(EntityConstants.MICROSOFT_AUTH_CODE, {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        body: new URLSearchParams({
          client_id: AppConstants.MICROSOFT_CLIENT_ID,
          scope: AppConstants.MICROSOFT_SCOPE,
          code: code,
          redirect_uri: redirectUri,
          grant_type: AppConstants.MICROSOFT_GRANT_TYPE,
          code_verifier: codeVerifier,
        }),
      });

      if (response.ok) {
        const data = await response.json();
        const loginStatus = await MLogin(data.access_token);
        if (loginStatus) {
          authContext.login();
          authContext.microsoftLogin();
        }
        sessionStorage.removeItem("pkce_code_verifier");
        window.history.replaceState(
          {},
          document.title,
          window.location.pathname + window.location.hash,
        );
        setCode("");
      } else {
        let message = t("navbar:microsoft_token_failed");
        try {
          const errorData = await response.json();
          console.error("Failed to fetch access token: ", errorData);
          if (errorData?.error_description) {
            message = errorData.error_description;
          }
        } catch {
          console.error(
            "Failed to fetch access token, status:",
            response.status,
          );
        }
        sessionStorage.removeItem("pkce_code_verifier");
        setCode("");
        window.history.replaceState(
          {},
          document.title,
          window.location.pathname + window.location.hash,
        );
        toast.error(message);
      }
    } catch (error) {
      console.error("Error during token exchange: ", error);
      sessionStorage.removeItem("pkce_code_verifier");
      setCode("");
      window.history.replaceState(
        {},
        document.title,
        window.location.pathname + window.location.hash,
      );
      toast.error(t("navbar:microsoft_token_failed"));
    }
  };

  const handleLanguageChange = (selectedOption) => {
    setLanguage(selectedOption);
  };

  const handleLanguageSwitch = (langCode) => {
    const selected = availableLanguages.find((l) => l.value === langCode);
    if (selected) {
      handleLanguageChange(selected);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await GET(EntityConstants.GET_ORGANISATION_DETAILS);
        const data = await response.json();

        if (response.ok) {
          setAuthProviders(data.auth_providers || []);
        } else {
          toast.error("Failed to fetch data");
        }
      } catch (error) {
        toast.error("Something went wrong");
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    setCode(urlParams.get("code"));
  }, []);

  useEffect(() => {
    code && handleMicrosoftRedirect();
  }, [code]);

  const path = location.pathname;

  useEffect(() => {
    const path = location.pathname;

    // Check if the path is not equal to "/" and doesn't start with "/discover/"
    if (!path.startsWith("discover/")) {
      // Handle the redirect or any other action you want to perform
      //if check for auth_token if exists then call handleCurrentUser().
      localStorage.getItem("auth_token") && handleCurrentUser("password");
    }
  }, [authContext.isLoggedIn, location.pathname]);

  useEffect(() => {
    if (authContext.isGoogleLogin) {
      localStorage.getItem("auth_token") && handleCurrentUser("google");
    }
  }, [authContext.isGoogleLogin]);

  useEffect(() => {
    if (language?.value) {
      i18n.changeLanguage(language.value);
      authContext.setSelectedLanguage(language.value);
      localStorage.setItem("selectedLanguage", language.value);
      document.documentElement.lang = language.value;
    }
  }, [language?.value, i18n]);

  useEffect(() => {
    const regex = /^http:\/\/localhost:3000\/verifier\/validate\/[a-f0-9]{64}$/;

    if (!regex.test(location.pathname)) {
      authContext.isFormDataChangedHandler(false);
      authContext.isConfirmationModalOpenHandler(false);
      authContext.pendingNavigationHandler(null);
    }
  }, [location.pathname]);

  return (
    <div className="sticky top-0">
      <Disclosure
        as="nav"
        className="bg-cfSecondary border-b-[1.5px]"
        style={{ backgroundColor: navbarBgColor || "#FFFFFF" }}
      >
        {({ open }) => (
          <>
            <div className="mx-auto px-4 sm:px-6 lg:px-8">
              <div className="flex h-[5rem] items-center justify-between">
                <NavLink
                  id="navbar-logo-link"
                  to={home}
                  className={
                    "flex items-center hover:text-inherit hover:no-underline focus:outline-none cursor-auto"
                  }
                >
                  <img
                    src={navbarLogo}
                    alt="Credflow"
                    className="h-16 w-auto max-w-[220px] object-contain"
                  />
                </NavLink>
                <div className="flex items-center gap-5">
                  {isLanguageSwitchEnabled() &&
                    availableLanguages.length > 1 && (
                      <LanguageSwitch
                        onLanguageChange={handleLanguageSwitch}
                      />
                    )}
                  {authContext.isLoggedIn && (
                    <>
                      <p>
                        <img
                          src={NotificationIcon}
                          alt=""
                          className="min-w-[1.50rem]  w-7 cursor-pointer hidden"
                        />
                      </p>
                      <p>
                        <img
                          src={HelpIcon}
                          alt=""
                          className="min-w-[1.50rem] w-7 cursor-pointer hidden"
                        />
                      </p>
                    </>
                  )}
                  <div className="flex items-center">
                    {authContext.isLoggedIn &&
                    Object.values(authContext.userDetails).length !== 0 ? (
                      <Menu as="div" className="relative">
                        <div>
                          <Menu.Button
                            id="navbar-profile-menu-button"
                            className="flex max-w-xs items-center text-md text-cfNavBarText focus:outline-none pr-4"
                          >
                            {authContext.userDetails.profile_photo ? (
                              <span className="flex items-center gap-1">
                                <img
                                  className="h-8 w-8 rounded-full"
                                  src={authContext.userDetails.profile_photo}
                                  alt=""
                                />
                                <p>{authContext.userDetails?.first_name}</p>
                                <p>{authContext.userDetails?.last_name}</p>
                              </span>
                            ) : (
                              <span className="flex items-center gap-1">
                                <img
                                  src={ProfileIcon}
                                  alt=""
                                  srcSet=""
                                  className="text-gray-400 w-7"
                                />
                                <p>{authContext.userDetails?.first_name}</p>
                                <p>{authContext.userDetails?.last_name}</p>
                              </span>
                              // <BiSolidUserCircle size={35} className="text-gray-400"/>
                            )}
                          </Menu.Button>
                        </div>
                        <Menu.Items className="flex flex-col text-gray-500 absolute right-0 z-10 mt-2 px-2 text-md w-max origin-top-right rounded-md bg-cfSecondary py-1 shadow-lg ring-1 ring-cfSecondary ring-opacity-5 focus:outline-none">
                          <div>
                            {!isLanguageSwitchEnabled() &&
                              availableLanguages.length > 1 && (
                              <div className="flex items-center pl-2">
                                <LanguagesIcon className="text-gray-600 w-5 h-5" />
                                <select
                                  id="navbar-language-select"
                                  value={
                                    language?.value ||
                                    availableLanguages[0]?.value
                                  }
                                  onChange={(e) => {
                                    const selected = availableLanguages.find(
                                      (l) => l.value === e.target.value,
                                    );
                                    handleLanguageChange(selected);
                                  }}
                                  className="language-dropdown focus:outline-none border-none w-full"
                                >
                                  {availableLanguages.map((lang) => (
                                    <option key={lang.value} value={lang.value}>
                                      {lang.label}
                                    </option>
                                  ))}
                                </select>
                              </div>
                            )}
                            {!isLanguageSwitchEnabled() &&
                              availableLanguages.length > 1 && <hr />}
                            <Menu.Item className="px-2 pb-1 py-2">
                              <NavLink
                                id="navbar-profile-link"
                                to={
                                  path === "/" ? "verifier/profile" : "profile"
                                }
                                className="hover:no-underline hover:text-gray-600 text-cfNavBarText flex items-center gap-1"
                              >
                                <div className="w-4 h-4 rounded-full flex items-center justify-center">
                                  {authContext.userDetails.profile_photo ? (
                                    <img
                                      src={
                                        authContext.userDetails.profile_photo
                                      }
                                      alt=""
                                      srcSet=""
                                      className="w-4 h-4 rounded-full"
                                    />
                                  ) : (
                                    <img
                                      src={ProfileIcon}
                                      alt=""
                                      srcSet=""
                                      className="w-4 h-4 rounded-full"
                                    />
                                  )}
                                </div>
                                &nbsp;
                                {authContext.userDetails?.first_name}&nbsp;
                                {authContext.userDetails?.last_name}
                              </NavLink>
                            </Menu.Item>
                            <hr />
                            <Menu.Item className="px-2 py-1">
                              <button
                                id="navbar-logout-button"
                                type="button"
                                className="flex items-center gap-1 hover:text-gray-600 text-cfNavBarText bg-cfSecondary focus:outline-none"
                                onClick={logout}
                              >
                                <BiLogOutCircle />
                                <p className="ml-1">
                                  {t("homeAuthPages:sign_out")}
                                </p>
                              </button>
                            </Menu.Item>
                          </div>
                        </Menu.Items>
                      </Menu>
                    ) : !isLanguageSwitchEnabled() &&
                      availableLanguages.length > 1 ? (
                      <div className="flex items-center gap-3 justify-between">
                        <Menu as="div" className="relative">
                          <Menu.Button
                            id="navbar-language-menu-button"
                            className="flex items-center justify-center p-2 rounded-md hover:bg-gray-100 transition-colors focus:outline-none"
                          >
                            <LanguagesIcon className="h-5 w-5 text-gray-600" />
                          </Menu.Button>
                          <Menu.Items className="absolute right-0 z-10 mt-2 w-40 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
                            <div className="">
                              {availableLanguages.map((lang) => (
                                <Menu.Item key={lang.value}>
                                  {({ active }) => (
                                    <button
                                      id={`navbar-language-${lang.value}-button`}
                                      className={`${
                                        active
                                          ? "bg-gray-100 text-gray-900"
                                          : "text-gray-700"
                                      } ${
                                        language?.value === lang.value
                                          ? "bg-blue-50 text-blue-600 font-medium"
                                          : ""
                                      } flex w-full items-center rounded-md px-3 py-2 text-sm`}
                                      onClick={() => handleLanguageChange(lang)}
                                    >
                                      {lang.label}
                                    </button>
                                  )}
                                </Menu.Item>
                              ))}
                            </div>
                          </Menu.Items>
                        </Menu>
                      </div>
                    ) : null}
                  </div>
                </div>
              </div>
            </div>
          </>
        )}
      </Disclosure>
    </div>
  );
}
